// extracted by mini-css-extract-plugin
export default {"checkbox":"AreaTypeCheckboxField_checkbox__90L0Q"};